import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { getJioAdsProducts } from '../../../actions/bannerProducts';
import styles from './index.pcss';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import { segmentDatalayerPushData, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { fireOsmosPlpImpression, fireOsmosClickTracker } from '../../../utils/osmosPlpImpressionUtils';
import { getPlaAdsClientID } from '../../../refresh/selectors/featureFlagsSelector';
const cx = classNames.bind(styles);

const JioAdsWidget = props => {
  const { jioAdsProducts, isFromPDP = false, feedLogic = '', parentProductObj = {}} = props;
  console.log('🚀 ~ JioAdsWidget ~ jioAdsProducts:', jioAdsProducts);
  const {
    brickCode = '',
    productCode = '',
    brand = '',
    description = '',
    mainImage,
    discount,
    actualPrice,
    currentPrice,
    descriptionPageURL,
    averageRating,
    numUserRatings
  } = jioAdsProducts;
  useEffect(() => {
    const segmentProductObj = {
      product_position: 0,
      product_brand: jioAdsProducts?.brand,
      product_id: jioAdsProducts?.code,
      product_name: jioAdsProducts?.description,
      product_mrp: jioAdsProducts?.currentPrice,
      product_list_price: Number(jioAdsProducts?.actualPricex) || 0,
      product_segment: jioAdsProducts?.segmentName,
      product_vertical: jioAdsProducts?.verticalName,
      product_brick: jioAdsProducts?.brickName,
      product_tag: '',
      product_rating: jioAdsProducts?.averageRating,
      product_wishlisted_count: '',
      catalog_id: jioAdsProducts?.catalogName,
      similar_product_icon_available_flag: false,
      ad_flag: true,
      ad_id: feedLogic,
      priority_delivery_edd: '',
      client_id: parentProductObj.client_id,
      ad_source: parentProductObj.ad_source,
      sku_id: jioAdsProducts?.code,
      uclid: jioAdsProducts?.uclid || '',
      scl_id: jioAdsProducts?.sclid || '',
      seller_id: jioAdsProducts?.sellerId || '',
    };
    const { ad_source, client_id, ...restParentProductObj } = parentProductObj || {};
    
    segmentEventPush({
      event: 'Product Viewed',
      ecommerce: { items: [{ ...segmentProductObj }] },
      impression_source: 'jioads_pdp_top',
      impression_type: ad_source === 'osmos' || jioAdsProducts?.uclid ? 'osmos_pdp_top' : 'jioads_pdp_top',
      ...restParentProductObj
    });

    jioAdsProducts?.uclid && fireOsmosPlpImpression({
      uclid: jioAdsProducts?.uclid || '',
      position: 0,
      page: 'PDP'
    });

    console.log('🚀 ~ useEffect ~ productItem:', segmentProductObj);
  }, []);
  const discountSplit = discount?.split(' ');
  const prodDiscount = discountSplit?.length > 0 ? discountSplit[0] : 0;
  if (!isFromPDP) {
    return <></>;
  }
  const renderStars = (averageRating) => {
  const fullStars = Math.floor(averageRating);
  const hasHalfStar = averageRating % 1 >= 0.5;
  const totalStars = 5;

  return (
    <div className={cx("stars")}>
      {[...Array(totalStars)].map((_, index) => {
        if (index < fullStars) {
          return <span key={index} className={cx("star", "full")}>★</span>;
        } else if (index === fullStars && hasHalfStar) {
          return <span key={index} className={cx("star", "half")}>★</span>;
        } else {
          return <span key={index} className={cx("star", "dimmed")}>★</span>;
        }
      })}
    </div>
  );
};

const getRatingLabel = (averageRating) => {
  return `${averageRating} out of 5 stars`;
};

const ariaLabel = [
  `Advertisement: ${brand} - ${description}`,
  averageRating && getRatingLabel(averageRating),
  currentPrice && `Current Price: ${currentPrice}`,
  actualPrice && actualPrice !== currentPrice && `Strike off ${actualPrice}`,
  discount && actualPrice !== currentPrice && `${prodDiscount} OFF`,
].filter(Boolean)
  .join(', ');

  return (
    <div className={cx('jioAds-product-card')} role="link" tabIndex={0} onClick={() => {
                fireOsmosClickTracker(jioAdsProducts?.uclid || '', 'PDP');
                 segmentEventPush({
                    event:'Widget Clicked', 
                    screen_name: 'pdp screen',
                    widget_id:  jioAdsProducts?.uclid ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
                    widget_name: jioAdsProducts?.uclid ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
                    widget_position: 0,
                    widget_type: jioAdsProducts?.uclid ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
                    ad_source: jioAdsProducts?.uclid ? 'osmos' : 'jioads',
                    client_id:  getPlaAdsClientID(window?.__PRELOADED_STATE__) || '',
                  });
                window.location.href = descriptionPageURL;
    }} aria-label={ariaLabel}
    >
      <img src={replaceWithJioCDN(mainImage)} alt="Product Image" className="product-image" />
      <div className={cx('product-info')}>
        <div className={cx('product-header')}>
          <span className={cx('product-title')}>
            {brand} - {description}
          </span>
          <span className={cx('ad-badge')}>AD</span>
        </div>

        <div className={cx('product-details')}>
          <div className={cx('product-price')}>
            {averageRating && renderStars(averageRating)}

            <div className={cx('price-details')}>
              <span className={cx('current-price')}>{currentPrice}</span>
              {!!actualPrice && actualPrice !== currentPrice ? (
                <span className={cx('old-price')}>{actualPrice}</span>
              ) : (
                <></>
              )}
              {!!discount && actualPrice !== currentPrice ? (
                <span className={cx('discount')}> {prodDiscount + ' OFF'}</span>
              ) : (
                <></>
              )}
            </div>
          </div>
          <a
            aria-hidden={true}
            tabIndex={-1}
            href={descriptionPageURL}
            className={cx('visit-link', !averageRating && 'paddingTop')}
            onClick={e => {
              const segmentProductObj = {
                product_position: 0,
                product_brand: jioAdsProducts?.brand,
                product_id: jioAdsProducts?.code,
                product_name: jioAdsProducts?.description,
                product_mrp: jioAdsProducts?.currentPrice,
                product_list_price: Number(jioAdsProducts?.actualPricex) || 0,
                product_segment: jioAdsProducts?.segmentName,
                product_vertical: jioAdsProducts?.verticalName,
                product_brick: jioAdsProducts?.brickName,
                product_tag: '',
                product_rating: jioAdsProducts?.averageRating,
                product_wishlisted_count: '',
                catalog_id: jioAdsProducts?.catalogName,
                similar_product_icon_available_flag: false,
                ad_flag: true,
                ad_id: feedLogic,
                priority_delivery_edd: ''
              };

              segmentDatalayerPushData({
                event: 'Product Clicked',
                ecommerce: { items: [{ ...segmentProductObj }] },
                impression_source: 'jioads_pdp_top',
                impression_type: jioAdsProducts?.ad_source === 'osmos' || jioAdsProducts?.uclid ? 'osmos_pdp_top' : 'jioads_pdp_top',
                ...parentProductObj
              });

              console.log('🚀 ~ productItem:', segmentProductObj);

              // Prevent default anchor behavior to delay navigation
              e.preventDefault();

              fireOsmosClickTracker(jioAdsProducts?.uclid || '', 'PDP');

              // Navigate after short delay
              setTimeout(() => {
                window.location.href = descriptionPageURL;
              }, 100); // 100ms is usually enough for tracking call
            }}
          >
            Visit
          </a>
        </div>
      </div>
    </div>
  );
};

export default JioAdsWidget;
